import { Page as AnvilPage } from '@servicetitan/anvil2';
import { FC } from 'react';
import { PageRouting } from '../../routing';

export const Page: FC = () => {
    return (
        <AnvilPage>
            <PageRouting />
        </AnvilPage>
    );
};
